import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
export const getEditAvatarUrl = () => `${getFullUrl('app')}/user-preferences/${PortalIdParser.get()}/basic`;
export const getAssetListingUrl = () => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets`;
export const getThemeAssetListingUrl = () => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets/themes/listings`;
export const getModuleAssetListingUrl = () => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets/modules/listings`;
export const getLegacyAssetListingUrl = subType => `${getFullUrl('app')}/providers/${PortalIdParser.get()}/products?subType=${subType}`;
export const getCreateAssetUrl = () => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets/create`;
export const getCreateLegacyAssetUrl = subTypePath => `${getFullUrl('app')}/providers/${PortalIdParser.get()}/products/list/${subTypePath}`;
export const getAssetProviderProfileUrl = tab => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets/profile?activeTab=${tab}`;
export const getLegacyAssetProviderProfileUrl = () => `${getFullUrl('app')}/providers/${PortalIdParser.get()}/profile`;
export const getAssetTransactionsUrl = () => `${getFullUrl('app')}/marketplace-providers/${PortalIdParser.get()}/assets/transactions`;
export const getLegacyAssetTransactionsUrl = subType => `${getFullUrl('app')}/providers/${PortalIdParser.get()}/transactions?subType=${subType}`; // TODO add nl and it once supported

export const getLocalizedHubSpotUrl = (lang, subdomain = 'www') => {
  switch (lang) {
    case 'de':
    case 'es':
    case 'fr':
      return `https://${subdomain}.hubspot.${lang}`;

    case 'ja':
      return `https://${subdomain}.hubspot.jp`;

    case 'pt':
      return 'https://br.hubspot.com';

    default:
      return `https://${subdomain}.hubspot.com`;
  }
};
const tierGroupPricingPath = {
  CRM: '/crm',
  MARKETING: '/marketing',
  SALES: '/sales',
  SERVICE: '/service',
  CMS: '/cms',
  OPERATIONS: '/operations',
  OPS: '/operations' // Remove once backend changes plans to use "OPERATIONS_" prefix

};
export const getPricingUrl = (isPublic, hub, lang = 'en') => {
  const path = tierGroupPricingPath[hub] || '';

  if (isPublic) {
    return `${getLocalizedHubSpotUrl(lang)}/pricing${path}`;
  }

  return `${getFullUrl('app')}/pricing/${PortalIdParser.get()}${path}`;
}; // TODO add lang types

export function getFullPublicUrl(lang, overrideConfig = {}) {
  const url = getFullUrl('ecosystem', Object.assign({}, overrideConfig, {
    hubletOverride: 'na1'
  }));

  switch (lang) {
    case 'de':
    case 'es':
    case 'fr':
    case 'it':
    case 'ja':
    case 'nl':
    case 'pt':
      return `${url}/${lang}`;

    default:
      return url;
  }
}